import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"map, paper"} maskId="square-filled-radius-0-stroke-1-IconMap"><path d="M2 5.78039L8 3.64706V18.5751L2 20.7084V5.78039Z" fill="currentColor"/><path d="M15 20.3703L9 18.5417V3.62962L15 5.45819V20.3703Z" fill="currentColor"/><path d="M16 20.3528L22 18.2195V3.2915L16 5.42484V20.3528Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMap;
